import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  OnDestroy,
} from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { tap, takeUntil, debounceTime } from 'rxjs/operators';

@Component({
  selector: 'lum-ui-input-button-group',
  templateUrl: './ui-input-button-group.component.html',
  styleUrls: ['./ui-input-button-group.component.scss'],
})
export class UiInputButtonGroupComponent implements OnInit, OnDestroy {
  @Input()
  label :string = '';

  @Input()
  placeholder :string = '';

  @Input()
  disabledInput :boolean = false;

  @Input()
  disabledButton :boolean = false;

  @Input()
  value :any = '';

  @Input()
  debounceTime :number = 0;

  @Output()
  clickEvent = new EventEmitter();

  @Output()
  inputChangeEvent = new EventEmitter<string>();

  private inputUpdated$ = new Subject<string>();
  private onDestroy$ = new Subject();

  constructor() {}

  ngOnInit() :void {
    this.onInputUpdate().subscribe();
  }

  ngOnDestroy() :void {
    this.onDestroy$.next(null);
    this.onDestroy$.complete();
  }

  onButtonClick() :void {
    this.clickEvent.emit();
  }

  onInputChange(event :any) :void {
    this.inputUpdated$.next(event.target.value);
  }

  private onInputUpdate() :Observable<string> {
    return this.inputUpdated$.asObservable().pipe(
      debounceTime(this.debounceTime),
      tap((value :string) => {
        this.inputChangeEvent.emit(value);
      }),
      takeUntil(this.onDestroy$),
    );
  }
}
